import React from 'react';
import ReactTable from "react-table";

import { Link, Switch, Route } from 'react-router-dom';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import config from '../../config'

import { TableComponent, connect } from "../tableComponent";

class Component extends TableComponent {

  apiPath = "payouts/load"
  noCache = false

  initialState = {
    agents: false
  }

  makeColumns = () => {
    return [
      {
        Header: "Wid",
        minWidth: 57,
        accessor: "aid"
      },
      {
        Header: "Name",
        id: "name",
        minWidth: 200,
        style: {"overflow": "auto"},
        accessor: (d) => d.name || d.firstname+" "+d.lastname,
        Cell: props => <span>{props.original.email}<br/>{props.value}</span>
      },
      {
        Header: "Skype",
        accessor: "skype",
        style: {"overflow": "auto"},
        minWidth: 170,
      },
      {
        Header: "Period",
        accessor: "from_date",
        minWidth: 90,
        filterable: false,
        Cell: props => <span>{props.value}<br/>{props.original.to_date}</span>
      },       
      {
        Header: "Earnings",
        accessor: "earned",
        minWidth: 100,
        filterable: false,
        Cell: props => <span>$ {props.value}</span>,
        Footer: props => <b>$ {this.props.total.earned}</b>
      },          
      {
        Header: "Action",
        id: "action",
        accessor: "aid",
        minWidth: 140,
        filterable: false,
        Cell: (props) => {
          return (
            <div>          
              <Link class="btn btn-sm warning" to={config.basePath+"/affiliate/sales?wid="+props.value}>Sales</Link>
              <Link class="btn btn-sm warning ml-1 hidden" to={config.basePath+"/affiliate/earnings?wid="+props.value}>Earnings</Link>
            </div>
          )
        }
      }
    ]    
  }

  fetchParams = (state) => {
    return {
      agents: this.props.state.agents,
      no_cache: !!this.noCache      
    }
  }

  reload = (e) => {
    e.preventDefault()
    this.noCache = true
    this.fetchData()
    this.noCache = false
  }

  toggleAgentsMode = (e) => {
    const agents = e.target.value;  
    this.props.setState({agents},this.fetchData);
  }

  button = (name,value) => {
    return (
      <button 
        type="button" 
        class={"btn primary "+(this.props.state.agents == value ? 'active' : '')} 
        name="agents" 
        value={value}
        onClick={this.toggleAgentsMode}>
        {name}
      </button>
    )
  }

  tableParams = {
    filterable: true,
    manual: false
  }
  
  render() {
    return (
      <div>
        <div class="row">
          <div class="col-sm-8">
            <div class="btn-group">
              {this.button("Affiliates",0)}
              {this.button("Agents",1)}
            </div>
          </div>
          <div class="col-sm-4">
            <button type="button" class="btn pull-right primary" onClick={this.reload}>Reload</button>
          </div>
        </div>       
        <div class="row mt-2">
          <div class="col-sm-12">
            {this.reactTable()}       
          </div>
        </div>
      </div>
    );
  }
}

export default connect(Component,"payouts_load")